<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <path fill-rule="evenodd" d="M9.874 2.231a1.5 1.5 0 0 0-1.748 0L2.823 6.034a1.5 1.5 0 0 0 0 2.438l5.303 3.803a1.5 1.5 0 0 0 1.748 0l5.303-3.803a1.5 1.5 0 0 0 0-2.438L9.875 2.231Zm4.43 5.022L9 3.45 3.697 7.253 9 11.057l5.303-3.804Z" clip-rule="evenodd"/>
      <path d="M2.223 10.764a1.5 1.5 0 0 1 .274-.864L9 14.563 15.503 9.9a1.5 1.5 0 0 1-.352 2.083l-5.277 3.784a1.5 1.5 0 0 1-1.748 0l-5.277-3.784a1.5 1.5 0 0 1-.626-1.219Z"/>
    </g>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
    <clipPath id="b">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
